import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { PageNonAutoriseComponent } from './components/page-non-autorise/page-non-autorise.component';
import { PageNonTrouveeComponent } from './components/page-non-trouvee/page-non-trouvee.component';

// KeycloakAngularModule et l'initialisation keycloak ont été deplaces dans main.ts
// siute a la migration vers keycloak-angular 20, ce module ne gère plus que le routing et les pages d'erreur
@NgModule({
    imports: [AuthRoutingModule, CommonModule, PageNonAutoriseComponent, PageNonTrouveeComponent]
})
export class AuthModule {}
